import React, { PropTypes } from 'react';
import { dateFormat, fullDateFormat } from '../../utils';

const renderItem = (item, index) => {
  const getMarkup = () => item.description;
  return (
    <a
      key={index}
      className="news"
      href={item.link}
      target="_blank"
      rel="noopener noreferrer"
      title={item.title}
    >
      <article>
        <time dateTime="2016-08-24">{fullDateFormat(item.fullDate)}</time>
        <div className="articles-details">
          <h1>{item.title}</h1>
          <p dangerouslySetInnerHTML={{ __html: getMarkup() }} />
        </div>
      </article>
    </a>
  );
};

const List = ({ items = [] }) => (
  <div className="col-sm-12">
    {items.map(({ dates }, index) => (
      <div key={index}>
        <h2 className="month-divider">{dateFormat(dates[0].fullDate)}</h2>
        {dates.map(renderItem)}
      </div>
    ))}
  </div>
);

List.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      textDate: PropTypes.string.isRequired,
      dates: PropTypes.arrayOf(
        PropTypes.shape({
          link: PropTypes.string,
          title: PropTypes.string,
          date: PropTypes.string,
          description: PropTypes.string,
          thumbnail: PropTypes.string,
          fullDate: PropTypes.string.isRequired
        })
      ).isRequired
    })
  )
};

export default List;



// WEBPACK FOOTER //
// ./src/pages/press/components/List/List.js